export default __webpack_public_path__ + "static/enforcement-agency-services-587-user-guide-cce3bec8ff0d29c72c40aa7728a7c939.pdf";